import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space12,
    paddingBottom: theme.spacing.space100,
    overflowY: "auto",
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  title: {
    marginBottom: theme.spacing.space12,
  },
  section: {
    marginTop: theme.spacing.space32,
  },
}));
